module.exports = __webpack_public_path__ + "static/008257-201784e262441283cd0bfd17b1f86dc1.jpg";